import { InjectionToken } from '@angular/core';
import auth0 from 'auth0-js';
import { environment } from 'src/environments/environment';

export const AUTH0_WEBAUTH = new InjectionToken('auth0.WebAuth', {
  factory: () =>
    new auth0.WebAuth({
      domain: environment.auth0Config.domain,
      clientID: environment.auth0Config.clientId,
      audience: environment.auth0Config.audience,
    }),
});
